import { type CamelCased, type SocialItemEnum, type UserProfileRaw } from '@metapic-apps/shared'

import type { CreatorSocialProfile } from '@/lib/types/creator-detail.types'

export const normalizeCreatorSocialProfile = (
  profile: CamelCased<UserProfileRaw>,
): CreatorSocialProfile => ({
  id: profile.id,
  type: profile.platform as SocialItemEnum,
  identifier: profile.handle ?? '',
  isConnected: profile.state === 'connected',
  isPrimary: profile.isPrimary,
  profileId: profile.profileId,
})
